import { t } from "../i18n/index";

import { publishFrame } from "../parser/p26005";

export function parse26005Frame(packet) {
    console.log("parse26005Frame packet", packet)

    let items = [];

    let addHead = function (content, key) {
        items.push(`<div class="item-head ${key}">[${content}]</div>`);
    }

    let addSimpleItem = function (key, value, unit) {
        items.push(`<div class="item-info simple">
            <div class='key'>${key}:</div>
            <div class='value'>${value}${unit}</div>
        </div>`);
    }

    let addComplexItem = function (key, arr) {
        items.push(`<div class="item-info complex">
            <div class='key'>${key}:</div>
            <div class='value'>`);

        for (const item of arr) {
            items.push(`<div class="item-info simple">
                <div class='key'>${ item.key ? t(item.key) + (item.content ? ':' : '') : '' }</div>
                <div class='value'>${ item.content || ''}</div>
            </div>`);
        }
        items.push(`</div></div>`);
    }

    let frame = packet['frame']
    if (!frame) {
        addHead(t(/*非法数据包*/'frame.illegal_data_packet'), 'illegal_data_packet');
    }


    let parsePayload = function (data) {
        for (let key in data) {
            try {
                let item = data[key];
                if (typeof item.content === 'object') {
                    addComplexItem(t(item.key), item.content)
                } else {
                    addSimpleItem(t(item.key), item.content, item.unit)
                }
            } catch (error) {
                console.log('parsePayload for error:', error)
            }
        }
    }

    let type = frame['type'] || 0;
    switch (type) {
        case 1: addHead(t(/*认证*/'frame.type.authentication'), 'authentication'); break;
        case 2: addHead(t(/*告警*/'frame.type.warning'), 'warning'); break;
        case 3: addHead(t(/*上报*/'frame.type.escalation'), 'escalation');
            let { data } = publishFrame(packet.data)
            parsePayload(data);
            break;
        case 4: addHead(t(/*心跳*/'frame.type.heartbeat'), 'heartbeat'); break;
    }
    return items.join('');
}